<template>
  <div class="demo-spin-article">
    <!-- DATA TABLE + PAGINATION -->
    <Table
      :loading="loading"
      :columns="columns"
      :data="data"
      class="desktop_table"
    >

    </Table>


    <!-- DATA MOBILE TABLE -->
    <div class="mobile-table">

      <div v-for="item in data" class="card-container">
        <div>
          <h2>№{{item.shiftTicketNumber}}</h2>
          <p>Время: {{formatDateTime(item.ticketTimeLocal)}}</p>
          <p>Скидка: {{formatNumber(item.amountDiscount)}} {{currency}}</p>
          <p>Сумма: {{formatNumber(item.amountTotal)}} {{currency}}</p>
        </div>

        <div>
          <Button type="primary" class="price" @click="fetchReportText(item.ticketId)"
                  style="border: none; color: #5087DE; text-decoration: underline; background: none; box-shadow: none; font-weight: bold"
          >Просмотр
          </Button>
        </div>

      </div>
    </div>

    <!--    <Page-->
    <!--      :total="totalRecords"-->
    <!--      :page-size="pageSize"-->
    <!--      :page-size-opts="[15, 25, 35]"-->
    <!--      @on-change="changePage"-->
    <!--      @on-page-size-change="changePageSize"-->
    <!--      show-sizer-->
    <!--      :styles="{ marginTop: '30px', float: 'right' }"-->
    <!--    />-->



    <Modal v-model="modalReport"
           title="Чек"
           width="300"
           cancelText="Закрыть"
           okText="Печать"
           :styles="{top: '20px'}"
    >
      <div>


        <div class="report_body" id="ticketModalBodyPrint">
          <h2 class="report_header">ДУБЛИКАТ</h2>

          <div class="report_text">{{ reportText }}</div>

<!--          <div style="max-width: 233px; margin: 0 auto; text-align: center">-->
          <div class="report_qr">
            <qrcode-vue :value="qrValue" level="H"></qrcode-vue>
          </div>
        </div>


      </div>
      <div slot="footer">
        <Button type="success" size="large" @click="modalPrint">Печать</Button>
        <Button type="error" size="large" @click="modalClose">Закрыть</Button>
      </div>
    </Modal>






  </div>
</template>
<script>
    import {base_url} from "../../http.js";
    import {BaseTableData} from "../../base/base_table.js";
    import {b64DecodeUnicode} from "../../base/base_func";
    import QrcodeVue from 'qrcode.vue'
    import print from 'print-js'

    let _app = BaseTableData();
    _app.props = {
        shift_id: Number
    };

    _app.components = {
        QrcodeVue
    };

    _app.data = function () {
        return {
            // Base settings
            baseViewUrl: base_url + `/proxy/shifts/${this.shift_id}/tickets/`,
            // item_type: "report",
            loading: true,

            // Table settings
            columns: [
                {
                    title: "№",
                    // width: 340,
                    key: "shiftTicketNumber"
                    // sortable: true,
                },
                {
                    title: "Время",
                    // width: 80,
                    align: "center",
                    // key: "order_date_display",
                    // sortable: true,
                    render: (h, params) => {
                        return h("span", {}, this.formatDateTime(params.row.ticketTimeLocal));
                    }
                },
                {
                    title: "Скидка",
                    // width: 80,
                    key: "amountDiscount",
                    align: "right",
                    sortable: true,
                    render: (h, params) => {
                        return h(
                            "div",
                            {},
                            this.formatNumber(params.row.amountDiscount) + " " + this.currency
                        );
                    }
                },
                {
                    title: "Сумма",
                    // width: 80,
                    key: "amountTotal",
                    align: "right",
                    sortable: true,
                    render: (h, params) => {
                        return h(
                            "div",
                            {},
                            this.formatNumber(params.row.amountTotal) + " " + this.currency
                        );
                    }
                },
                {
                    title: "Просмотр",
                    // width: 80,
                    // key: "total_sum",
                    align: "center",
                    // sortable: true,
                    render: (h, params) => {
                        return h(
                            "Button",
                            {
                                props: {type: "primary"},
                                nativeOn: {
                                    click: this.showReportAction(params.row.ticketId)
                                },
                                style: {
                                    border: 'none',
                                    color: '#5087DE',
                                    textDecoration: 'underline',
                                    background: 'none',
                                    boxShadow: 'none',
                                    fontWeight: 'bold'
                                }
                            },

                            "ПРОСМОТР"
                        );
                    }
                }
            ],
            data: [],
            lastDraw: 0,
            // totalRecords: null,
            // currentPage: 1,
            // pageSize: 999999999999,
            // sorting: "",

            modalReport: false,
            reportText: "",
            qrValue: ''
        };
    };

    _app.computed.currency = function () {
        return this.$store.state.currency;
    };

    _app.computed.fetchParams = function () {
        return {
            // format: "table",
            // shift: this.shift_id
        };

    };


    _app.methods.modalPrint = function() {
        printJS({
            printable: 'ticketModalBodyPrint',
            type: 'html',
            style: `.report_body {
  box-sizing: border-box;
  color: rgb(0, 0, 0);
  font-family: Consolas, serif;
  font-size: 8px;
  font-weight: 400;
  line-height: 15px;
  overflow-wrap: break-word;
  pointer-events: auto;
  text-align: left;
  white-space: pre-wrap;
}
.report_header {
  font-size: 18px;
  font-weight: 400;
  text-align: center;
 }

.report_text {
  display: flex;
  justify-content: center;
  overflow: hidden;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  font-family: Consolas;
  line-height: 15px;
  font-size: 15px;
  font-weight: 400;
  font-style: normal;
  color: #000;
  background-color: transparent;
}
  .report_qr {
    max-width: 233px;
    margin: 0 auto;
    text-align: center;
  }
`

        });
    };
    _app.methods.modalClose = function () {
        this.modalReport = false;
    };

    // Загружаем данные для таблицы
    _app.methods.fetchItems = function () {
        this.loading = true;
        this.lastDraw++;
        let url = `${base_url}/proxy/shifts/${this.shift_id}/tickets/`;
        this.$http
            .get(url, {
                params: this.fetchParams
            })
            .then(result => {
                // if (result.data.draw === this.lastDraw) {
                this.data = result.data.tickets;
                // this.totalRecords = result.data.count;
                // }
            })
            .finally(() => {
                this.loading = false;
            });
    };

    _app.methods.b64DecodeUnicode = function (str) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return b64DecodeUnicode(str);
    };

    _app.methods.fetchReportText = function (ticket_id) {
        const url = `${base_url}/proxy/tickets/${ticket_id}/`;
        this.reportText = "";
        this.qrValue = "";
        this.$http
            .get(url)
            .then(result => {

                this.reportText = this.b64DecodeUnicode(result.data.receipt);
                this.qrValue = this.b64DecodeUnicode(result.data.ofdQrCode);

                this.modalReport = true;
                // console.log(this.reportText);
                // this.filterOptions.cash = result.data.results;
            })
            .catch(error => {
                this.$Message.error("Произошла ошибка");
            });
    };

    _app.methods.showReportAction = function (ticket_id) {
        return () => {
            this.fetchReportText(ticket_id);
        };
    };

    // _app.created = function(){
    //   console.log(shift_id)
    // };

    export default _app;
</script>

<style scoped>
  .report_body {
    /*width: 420px;*/
    box-sizing: border-box;
    color: rgb(0, 0, 0);
    font-family: Consolas, serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 15px;
    overflow-wrap: break-word;
    pointer-events: auto;
    text-align: left;
    white-space: pre-wrap;
  }

  .report_header {
    /*color: rgb(42, 42, 42);*/
    font-size: 18px;
    font-weight: 500;
    line-height: 19.2px;
    /*margin-bottom: 8px;*/
    /*margin-top: 0px;*/
    /*pointer-events: auto;*/
    text-align: center;
    /*visibility: visible;*/
  }

  .report_text {
    display: flex;
    justify-content: center;
    overflow: hidden;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    font-family: Consolas;
    line-height: 15px;
    font-size: 15px;
    font-weight: 400;
    font-style: normal;
    color: #000;
    background-color: transparent;
  }

  .report_qr {
    max-width: 233px;
    margin: 0 auto;
    text-align: center;
  }

</style>






// WEBPACK FOOTER //
// src/apps/money_order/ticketHistoryExpand.vue